var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "modal-h1 mb-3" }, [
        _c("button", {
          staticClass: "btn btn-back",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              _vm.$emit("cancel")
            }
          }
        }),
        _vm._v(" "),
        _vm.typeId === 1
          ? _c("span", [_vm._v("\n      Send a customer email\n    ")])
          : _vm._e(),
        _vm._v(" "),
        _vm.typeId === 2
          ? _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.job.ref_id) +
                  " - Send an acknowledgement email\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.typeId === 3
          ? _c("span", [_vm._v("\n      Send a settlement email\n    ")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.variablesLoaded && _vm.templateLoaded
        ? _c("div", { staticClass: "l-bg-white" }, [
            _c("div", { staticClass: "row mb-1" }, [
              _c(
                "div",
                { staticClass: "col pl-3 pr-1" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Email")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: {
                          options: _vm.customerContactsWithEmail,
                          label: "email",
                          "return-value": "email",
                          placeholder: "Select recipient"
                        },
                        model: {
                          value: _vm.customer_email_selected,
                          callback: function($$v) {
                            _vm.customer_email_selected = $$v
                          },
                          expression: "customer_email_selected"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "to" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col pl-1" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col-6 pr-1" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Subject")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.claimEmail.subject,
                          expression: "claimEmail.subject"
                        }
                      ],
                      ref: "subject",
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.claimEmail.subject },
                      on: {
                        click: function($event) {
                          _vm.addingVariableOn = "subject"
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.claimEmail,
                            "subject",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "subject" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 pl-1" }, [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Choose from template")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        options: _vm.claimEmail.emailTemplates,
                        placeholder: "Select template"
                      },
                      on: { input: _vm.loadEmailTemplate },
                      model: {
                        value: _vm.claimEmail.template,
                        callback: function($$v) {
                          _vm.$set(_vm.claimEmail, "template", $$v)
                        },
                        expression: "claimEmail.template"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("div", { staticClass: "select-wrap h-auto" }, [
                    _c("label", [_vm._v("Email body")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.claimEmail.body,
                          expression: "claimEmail.body"
                        }
                      ],
                      ref: "ta",
                      staticClass: "select-wrap-textarea form-control",
                      attrs: { name: "", id: "", cols: "30", rows: "10" },
                      domProps: { value: _vm.claimEmail.body },
                      on: {
                        click: function($event) {
                          _vm.addingVariableOn = "ta"
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.claimEmail, "body", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "body" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "div",
                  _vm._l(_vm.claimEmail.variables, function(
                    variable,
                    key,
                    index
                  ) {
                    return _c(
                      "span",
                      {
                        key: index,
                        staticClass:
                          "badge badge-primary mx-1 unselectable pointer",
                        on: {
                          click: function($event) {
                            _vm.insertVariable(variable)
                          }
                        }
                      },
                      [_vm._v(_vm._s(key))]
                    )
                  })
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-4" }, [
              _c("div", { staticClass: "col text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.closeModal()
                      }
                    }
                  },
                  [_vm._v("\n          Discard\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ld-ext-right",
                    class: _vm.loadingButton ? "running" : "",
                    attrs: { type: "button", disabled: _vm.buttonDisabled },
                    on: { click: _vm.sendEmail }
                  },
                  [
                    _vm._v("\n          Send Email\n          "),
                    _c("div", { staticClass: "ld ld-ball ld-flip" })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "settlement" }
                  })
                ],
                1
              )
            ])
          ])
        : [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fdd412e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fdd412e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/Modals/SendClaimEmail.vue
// module id = null
// module chunks = 